import { get, post } from '../../../components/hooks/apiFetch';

export const useInvoiceRecognizerApi = () => {
    const submitInvoiceRecognizerRequest = async (filesWithFormats, comment = '', startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
        });

        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        const result = await post(`/api/invoicerecognizer`, formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelInvoiceRecognizerTask = async (inputIdentifier) => {
        await get(`/api/invoicerecognizer/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitInvoiceRecognizerRequest, cancelInvoiceRecognizerTask };
};